<template>
  <ViewCover style="height: 100%" class="d-flex flex-column" >
    <v-toolbar elevation="2" dense class="shrink" >
      <v-toolbar-title style="min-width: 50%">      
        <T>Новый заказ</T>
        <v-menu>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              text
              color="primary"
              dark
              v-bind="attrs"
              v-on="on"
              min-width="180"
              small
            >
              <span v-if="orderType == 'delivery'">
                <v-icon class="mr-1">mdi-truck-fast-outline</v-icon>
                <T :key="1">Доставка</T>
              </span>
              <span v-if="orderType == 'takeaway'">
                <v-icon class="mr-1">mdi-food-outline</v-icon>
                <T :key="2">Самовывоз</T>
              </span>
              <v-icon>mdi-menu-down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="orderType = 'delivery'">
              <v-list-item-title>
                <v-icon class="mr-2">mdi-truck-fast-outline</v-icon>
                <T>Доставка</T>
              </v-list-item-title>
            </v-list-item>
            <v-list-item @click="orderType = 'takeaway'">
              <v-list-item-title>
                <v-icon class="mr-2">mdi-food-outline</v-icon>
                <T>Самовывоз</T>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-progress-circular v-if="loading || validating" size="25" indeterminate color="primary" ></v-progress-circular>
      </v-toolbar-title>
      <transition name="fade" duration="100">
        <v-tabs v-model="tab" right>
          <v-tab>
            <v-icon class="mr-1">mdi-account</v-icon>
            <T>Гость</T>
          </v-tab>
          <v-tab>
            <v-icon class="mr-1">mdi-book-outline</v-icon>
            <T>Заказ</T>
          </v-tab>
          <v-tab>
            <v-icon class="mr-1">mdi-bookmark-check-outline</v-icon>
            <T>Оформление</T>
          </v-tab>
        </v-tabs>
      </transition>
    </v-toolbar>
    <transition name="fade" duration="100" mode="out-in">
      <v-tabs-items v-model="tab" class="mt-1 d-flex flex-column grow" touchless>
        <v-tab-item style="height: 100%">
          <NewOrderInfo 
            @onPhone="onPhone" 
            :phone="$store.getters.orderPhone"
            @onAddress="onAddress"
            :address="$store.getters.orderAddress"
            @onDeliveryZone="onDeliveryZone"
            :deliveryZone="$store.getters.deliveryZone"
            @removePhone="onRemovePhone"
            :orderType="$store.getters.orderType"
            @onGuest="onGuest"
            :guest="$store.getters.orderGuest"
            @removeAddress="e => removeAddress(e)"
          />
        </v-tab-item>
        <v-tab-item style="height: 100%">
          <OrderContentEditor 
            :validated_order="validated_order" 
            :validating="validating" 
            :loading="loading" 
            :order_type="$store.getters.orderType"
            @pushItem="pushItem"
            @incItem="incItem"
            @decItem="decItem"
            @delItem="delItem"
            :deliveryZone="$store.getters.deliveryZone"
          />
        </v-tab-item>
        <v-tab-item style="height: 100%">
          <PaymentInfo 
            :order="validated_order"
            :guest="$store.getters.orderGuest"
            :phone="$store.getters.orderPhone"
            :address="$store.getters.orderAddress"
            :orderType="$store.getters.orderType"
            :delivery_zone="$store.getters.deliveryZone"
            @onComment="onComment"
            :comment="$store.getters.orderComment"
            @onDeliveryDate="onDeliveryDate"
            :date="$store.getters.deliveryDate"
            @onPayment="onPayment"
            :payment_type="$store.getters.paymentType"
            @onSave="onSave"
            @onCancel="onCancel"
          />
        </v-tab-item>
      </v-tabs-items>
    </transition>
    <v-dialog max-width="600" v-model="templateDialog" persistent>
      <v-card>
        <v-card-title><T>Черновик заказа</T></v-card-title>
        <v-card-text>
          <T>Продолжить редактирование черновика, или создать новый заказ?</T>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" text @click="templateDialog = false">
            <T>Редактировать черновик</T>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="clearOrder(); templateDialog = false">
            <T>Новый заказ</T>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </ViewCover>
</template>

<script>
import { eventBus } from '../main'
import ViewCover from './ViewCover.vue'
import NewOrderInfo from '../components/orders/new_order/NewOrderInfo'
import OrderContentEditor from '../components/orders/new_order/OrderContentEditor'
import PaymentInfo from '../components/orders/new_order/PaymentsInfo'

export default {
  created(){
    eventBus.$on('dropOrder', () => {
      this.event_bus_dropped = true
      this.clearOrder()
    })

    eventBus.$on('addItems', async () => {
      this.validated_order = await this.$store.dispatch('validateOrder', this.$store.getters.validationOrderModel(this.$store.getters.orderItems))
    })
  },
  data: () => ({
    validated_order: {},
    delivery_zone: undefined,
    tab: 0,
    loading: true,
    validating: false,
    templateDialog: false,
    event_bus_dropped: false
  }),
  watch: {
    // При изменении зоны доставки удаляем старое блюдо и добавляем новое
    currentDeliveryZone(newZone, oldZone) {
      if(newZone && newZone !== oldZone) {
        // Если тип заказа "delivery" - пересоздаем блюдо доставки
        if(this.$store.getters.orderType === 'delivery') {
          (async () => {
            const deliveryDish = this.$store.getters.menu_items_map[this.$store.getters.config.r_keeper_references.dish_delivery];
            // Удаляем старое блюдо, если оно существует
            if(this.validated_order.items) {
              const existing = this.validated_order.items.find(item => item && item.id === deliveryDish.id);
              if(existing) {
                await this.delItem(existing.line_guid);
              }
            }
            
            let total = 0
            if (this.validated_order.items.some(item => item.id === deliveryDish)) {
              total = this.validated_order.order_total - this.$store.getters.deliveryZone.price_delivery
            } else {
              total = this.validated_order.order_total
            }
            if (total < this.$store.getters.deliveryZone.min_sum_for_delivery) {
              // Добавляем блюдо с единичным количеством
              await this.pushItem({
                id: Math.random() * 1000000000,
                product: deliveryDish,
                quantity: 1,
                modifiers: []
              });
            }
          })();
        }
      }
    },

    currentPriceOrder(newPrice) {
      const deliveryDish = this.$store.getters.config.r_keeper_references.dish_delivery
      let total = 0

      if (this.$store.getters.orderType === 'delivery') {
        if (this.validated_order.items.some(item => item.id === deliveryDish)) {
          total = newPrice - this.$store.getters.deliveryZone.price_delivery
        } else {
          total = newPrice
        }
        (async () => {
          if (total >= this.$store.getters.deliveryZone.min_sum_for_delivery) {
            if (this.validated_order.items.some(item => item.id === deliveryDish)) {
              if(this.validated_order.items) {
                const existing = this.validated_order.items.find(item => item && item.id === deliveryDish);
                if(existing) {
                  await this.decItem(existing.line_guid);
                }
              }
            }
          } else {
            await this.adjustDeliveryDish()
          }
        })();
      }
    }
  },
  methods: {
    // Универсальная функция для корректировки блюда доставки
    async adjustDeliveryDish() {
      const orderType = this.$store.getters.orderType;
      const deliveryDish = this.$store.getters.menu_items_map[this.$store.getters.config.r_keeper_references.dish_delivery];
      // Если доставка, гарантируем наличие ровно одной порции блюда доставки
      if (orderType === 'delivery') {
        let existing = this.validated_order.items && this.validated_order.items.find(item => item && item.id === deliveryDish.id);
        if (existing) {
          // Если количество не равно 1, корректируем его
          if (existing.quantity !== 1) {
            const diff = 1 - existing.quantity;
            // Изменяем количество через уже существующий экшен (или можно напрямую корректировать объект)
            this.validating = true;
            try {
              this.validated_order = await this.$store.dispatch('changeItemQuantity', { guid: existing.line_guid, quantity: diff });
            } finally {
              this.validating = false;
            }
          }
        } else {
          // Если блюда нет, добавляем одну порцию
          await this.pushItem({
            id: Math.random() * 1000000000,
            product: deliveryDish,
            quantity: 1,
            modifiers: []
          });
        }
      }
      // Если тип takeaway, удаляем блюдо, если оно присутствует
      else if (orderType === 'takeaway') {
        if (this.validated_order.items) {
          const existing = this.validated_order.items.find(item => item && item.id === deliveryDish.id);
          if (existing) {
            await this.decItem(existing.line_guid);
          }
        }
      }
    },
    // При выборе гостя – устанавливаем гостя и затем корректируем состав заказа.
    onGuest(guest) {
      this.$store.dispatch('setGuest', guest);
      const orderType = this.$store.getters.orderType;
      if (orderType === 'delivery') {
        // Если зона доставки ещё не установлена, ждём её появления
        const intervalId = setInterval(() => {
          if (this.$store.getters.deliveryZone) {
            this.adjustDeliveryDish();
            clearInterval(intervalId);
          }
        }, 1000);
      } else if (orderType === 'takeaway') {
        this.adjustDeliveryDish();
      }
    },
    onAddress(address) {
      this.$store.dispatch('setAddress', address)
    },
    onPhone(phone) {
      this.$store.dispatch('setPhone', phone)
    },
    async onDeliveryZone(zone) {
      this.validating = true
      try {
        this.validated_order = await this.$store.dispatch('setDeliveryZone', zone)
        // После установки зоны доставки – проверяем наличие блюда, если это доставка
        if(this.$store.getters.orderType === 'delivery'){
          await this.adjustDeliveryDish();
        }
      } finally {
        this.validating = false
      }
    },
    async onRemovePhone(phone) {
      this.loading = true
      try {
        await this.$store.dispatch('removePhone', phone)
        this.$store.dispatch('throwTimeoutMessage', {
          text: `${this.$t('Изменения сохранены')}`,
          message_class: 'success'
        })
      } finally {
        this.loading = false
      }
    },
    async pushItem(item) {
      this.validating = true
      try {
        this.validated_order = await this.$store.dispatch('pushItem', item)
      } finally {
        this.validating = false
      }
    },
    async incItem(guid) {
      this.validating = true
      try {
        this.validated_order = await this.$store.dispatch('changeItemQuantity', { guid, quantity: 1 })
      } catch(e) {
        let portion = this.$store.getters.orderItems[guid]
        const index = this.validated_order.items.findIndex(item => item.id === portion.product.id)
        if (index !== -1) {
          this.validated_order.items[index] = { 
            ...this.validated_order.items[index],
            quantity: portion.quantity
          }
        }
      } finally {
        this.validating = false
      }
    },
    async decItem(guid) {
      this.validating = true
      try {
        this.validated_order = await this.$store.dispatch('changeItemQuantity', { guid, quantity: -1 })
      } finally {
        this.validating = false
      }
    },
    async delItem(guid) {
      this.validating = true
      try {
        await this.$store.dispatch('delItem', { guid })
      } finally {
        this.validating = false
      }
    },
    onComment(comment) {
      this.$store.dispatch('setOrderComment', comment)
    },
    onDeliveryDate(date) {
      this.$store.dispatch('setDeliveryDate', date)
    },
    onPayment(payment_type) {
      this.$store.dispatch('setPaymentType', payment_type)
    },
    async onSave() {
      try {
        await this.$store.dispatch('saveNewOrder')
        this.$store.dispatch('throwTimeoutMessage', {
          message_data: this.$t('Заказ сохранен'),
          message_class: 'success'
        })
      } catch(e) {
        this.$store.dispatch('throwTimeoutMessage', {
          message_data: `${e.message}`,
          message_class: 'error'
        })
        return
      }
      this.clearOrder()
      this.$router.push({ path: '/' })
    },
    clearOrder() {
      this.$store.commit('dropOrder')
      this.validated_order = {}
    },
    onCancel() {
      this.clearOrder()
      this.$router.push('/')
    },
    async removeAddress(address) {
      this.loading = true
      try {
        await this.$store.dispatch('removeAddress', address)
        this.$store.dispatch('throwTimeoutMessage', {
          text: `${this.$t('Изменения сохранены')}`,
          message_class: 'success'
        })
      } finally {
        this.loading = false
      }
    },
  },
  computed: {
    orderType: {
      get() {
        return this.$store.getters.orderType
      },
      async set(v) {
        this.validating = true 
        try {
          this.validated_order = await this.$store.dispatch('setOrderType', v)
          // После смены типа заказа корректируем состав
          await this.adjustDeliveryDish();
        } finally {
          this.validating = false
        }
      }
    },
    // Для удобного отслеживания зоны доставки
    currentDeliveryZone() {
      // console.log('this.validated_order', this.validated_order)
      return this.$store.getters.deliveryZone;
    },
    currentPriceOrder() {
      return this.validated_order.order_total
    }
  },
  components: {
    ViewCover,
    NewOrderInfo,
    OrderContentEditor,
    PaymentInfo,
  },
  async mounted() {
    this.loading = true
    try {
      await this.$store.dispatch('loadMenu')
    } finally {
      this.loading = false
    }

    if (this.$store.getters.hasOrderMarkup && !this.event_bus_dropped) {
      this.templateDialog = true
    }

    if (Object.keys(this.$store.getters.orderItems).length) {
      let items = this.$store.getters.orderItems
      this.validated_order = await this.$store.dispatch('validateOrder', this.$store.getters.validationOrderModel(items))
    }
  }
}
</script>

<style>
.v-window__container {
  display: -webkit-box !important;
  flex-grow: 1;
}
</style>
